const prefix = '@Retire&Entrega:';

export enum LocalStorageKeys {
  AppVersion = `${prefix}app_version`,
  Attendances = `${prefix}attendances`,
  ConsignmentsToCollect = `${prefix}consignments_to_collect`,
  LabelSize = `${prefix}label_size`,
  NotifiedConsignments = `${prefix}notified_consignments`,
  NotifiedExpiringConsignments = `${prefix}notified_expiring_consignments`,
  SelectedStore = `${prefix}selected_store`,
  SoundNotification = `${prefix}sound_notification`,
  User = `${prefix}user`,
  DashboardSearch = `${prefix}dashboard_search`,
  DashboardFilter = `${prefix}dashboard_filter`,
  ReturnFilter = `${prefix}return_filter`,
  ReturnSearch = `${prefix}return_search`,
  InvoiceOption = `${prefix}invoice_option`,
  hadUrlDashboardFilterApplied = `${prefix}had_url_dashboard_filter_applied`,
  hadUrlReturnFilterApplied = `${prefix}had_url_return_filter_applied`,
  CheckedPickupProductsList = `${prefix}checked_pickup_products_list`,
  RegulatoryEmailSendTime = `${prefix}regulatory_email_send_time`,
  EmployeeData = `${prefix}employee_data`,
  ConfirmExchangeAndReturnReceived = `${prefix}confirm_exchange_and_return_received`,
  MenuExpanded = `${prefix}menu_expanded`,
}
